import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";

import OnlyHeader from "components/Layout/OnlyHeader.js";
import CatalogTable from "components/Catalog/CatalogTable";
import AddCatalogModal from "components/Modals/AddCatalogModal";
import DeleteCatalogModal from "components/Modals/DeleteCatalogModal";
import EditCatalogModal from "components/Modals/EditCatalogModal";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogsByID } from "store/actions/catalogAction";

const Catalog = () => {
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState("");
  const [id, setId] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { deleteCatalogLoading } = useSelector((state) => state.catalog);

  const dispatch = useDispatch();

  const addToggle = () => {
    setAddModal(!addModal);
  };
  const editToggle = () => {
    setEditModal(!editModal);
  };
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };
  useEffect(() => {
    dispatch(getCatalogsByID(user?.restaurantID));
  }, [dispatch, user?.restaurantID]);

  return (
    <>
      <OnlyHeader />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <CatalogTable
          addToggle={addToggle}
          editToggle={editToggle}
          deleteToggle={deleteToggle}
          setEditData={setEditData}
          setId={setId}
        />

        <AddCatalogModal addModal={addModal} addToggle={addToggle} />

        <EditCatalogModal
          editModal={editModal}
          editToggle={editToggle}
          editData={editData}
          id={id}
        />
        <DeleteCatalogModal
          deleteModal={deleteModal}
          deleteToggle={deleteToggle}
          title={"Catalog"}
          deleteLoading={deleteCatalogLoading}
          id={id}
        />
      </Container>
    </>
  );
};

export default Catalog;
